import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { destinoTrasLogin, esRutaAdmin } from "@/auth/destinos";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-slate-500" strokeWidth={1.5} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol === "admin") {
    if (esRutaAdmin(location.pathname)) return children;
    return <Navigate to={destinoTrasLogin("admin")} replace />;
  }
  if (roles && !roles.includes(user.rol)) return <Navigate to={destinoTrasLogin(user.rol)} replace />;
  return children;
}
